import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { PractitionerBilling } from "@/models/PractitionerBillingModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { toDateTime } from "@/utils/dateUtils.ts";

export type UpdatedAtColumnProps = CellContext<PractitionerBilling, string>;

export const UpdatedAtColumn: React.FC<UpdatedAtColumnProps> = ({ renderValue }) => {
  const updatedAt = renderValue() ?? "";

  return <Typography variant="body">{toDateTime(updatedAt).toLocaleString(DateTime.DATE_SHORT)}</Typography>;
};

export const UpdatedAtColumnHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Typography variant="bodyLarge" className={css({ fontWeight: "bold" })}>
      {t("pages.practitionerBilling.lastUpdate")}
    </Typography>
  );
};
